module.exports = __webpack_public_path__ + "static/media/one.87535d21.svg";